// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ABSOLUTE_CORRUPTION_TALENT: {
    id: 196103,
    name: 'Absolute Corruption',
    icon: 'ability_bossmannoroth_empoweredmannorothsgaze',
    maxRanks: 1,
    entryIds: [91572],
    definitionIds: [{ id: 96574, specId: 265 }],
  },
  ABYSSAL_DOMINION_TALENT: {
    id: 429581,
    name: 'Abyssal Dominion',
    icon: '70_inscription_vantus_rune_tomb',
    maxRanks: 1,
    entryIds: [117428],
    definitionIds: [{ id: 122440, specId: 267 }],
  },
  ABYSS_WALKER_TALENT: {
    id: 389609,
    name: 'Abyss Walker',
    icon: 'achievement_explore_argus',
    maxRanks: 1,
    entryIds: [91465],
    definitionIds: [{ id: 96467, specId: 267 }],
  },
  AGONY_TALENT: {
    id: 980,
    name: 'Agony',
    icon: 'spell_shadow_curseofsargeras',
    maxRanks: 1,
    entryIds: [91570],
    definitionIds: [{ id: 96572, specId: 265 }],
    manaCost: 2500,
  },
  ALYTHESSS_IRE_TALENT: {
    id: 1244941,
    name: "Alythess's Ire",
    icon: 'ability_ironmaidens_rapidfire',
    maxRanks: 1,
    entryIds: [91423],
    definitionIds: [{ id: 96425, specId: 267 }],
  },
  ALZZINS_INIQUITY_TALENT: {
    id: 1266803,
    name: "Alzzin's Iniquity",
    icon: 'spell_shadow_improvedvampiricembrace',
    maxRanks: 1,
    entryIds: [136093],
    definitionIds: [{ id: 140848, specId: 267 }],
  },
  ANNIHILANS_BELLOW_TALENT: {
    id: 429072,
    name: "Annihilan's Bellow",
    icon: 'ability_physical_taunt',
    maxRanks: 1,
    entryIds: [118837],
    definitionIds: [{ id: 123737, specId: 267 }],
  },
  ANTORAN_ARMAMENTS_TALENT: {
    id: 1250921,
    name: 'Antoran Armaments',
    icon: 'inv_plate_helmet_eredarargus_d_01',
    maxRanks: 1,
    entryIds: [135303],
    definitionIds: [{ id: 140070, specId: 266 }],
  },
  ASHEN_REMAINS_TALENT: {
    id: 387252,
    name: 'Ashen Remains',
    icon: 'inv_enchanting_dust',
    maxRanks: 2,
    entryIds: [91482],
    definitionIds: [{ id: 96484, specId: 267 }],
  },
  AURA_OF_ENFEEBLEMENT_TALENT: {
    id: 440059,
    name: 'Aura of Enfeeblement',
    icon: 'warlock_curse_weakness_aura',
    maxRanks: 1,
    entryIds: [123309],
    definitionIds: [{ id: 128179, specId: 267 }],
  },
  AVATAR_OF_DESTRUCTION_TALENT: {
    id: 1245089,
    name: 'Avatar of Destruction',
    icon: 'inv12_ability_warlock_overfiend',
    maxRanks: 1,
    entryIds: [136833],
    definitionIds: [{ id: 141596, specId: 267 }],
  },
  BACKDRAFT_TALENT: {
    id: 196406,
    name: 'Backdraft',
    icon: 'ability_warlock_backdraft',
    maxRanks: 1,
    entryIds: [91590],
    definitionIds: [{ id: 96592, specId: 267 }],
  },
  BACKLASH_TALENT: {
    id: 387384,
    name: 'Backlash',
    icon: 'spell_fire_playingwithfire',
    maxRanks: 2,
    entryIds: [91500],
    definitionIds: [{ id: 96502, specId: 267 }],
  },
  BANISH_TALENT: {
    id: 710,
    name: 'Banish',
    icon: 'spell_shadow_cripple',
    maxRanks: 1,
    entryIds: [91454],
    definitionIds: [{ id: 96456, specId: 267 }],
    manaCost: 3750,
  },
  BLACKENED_SOUL_TALENT: {
    id: 440043,
    name: 'Blackened Soul',
    icon: 'spell_nzinsanity_chasedbyshadows',
    maxRanks: 1,
    entryIds: [117434],
    definitionIds: [{ id: 122446, specId: 267 }],
  },
  BLEAKHEART_TACTICS_TALENT: {
    id: 440051,
    name: 'Bleakheart Tactics',
    icon: 'spell_shadow_mindshear',
    maxRanks: 1,
    entryIds: [123310],
    definitionIds: [{ id: 128180, specId: 267 }],
  },
  BLIGHTED_MAW_TALENT: {
    id: 1276956,
    name: 'Blighted Maw',
    icon: 'ability_creature_poison_01',
    maxRanks: 1,
    entryIds: [135310],
    definitionIds: [{ id: 140077, specId: 266 }],
  },
  BLIGHT_OF_TONGUES_TALENT: {
    id: 1271802,
    name: 'Blight of Tongues',
    icon: 'spell_shadow_curseoftongues_amplified',
    maxRanks: 1,
    entryIds: [136738],
    definitionIds: [{ id: 141510, specId: 267 }],
  },
  BLIGHT_OF_WEAKNESS_TALENT: {
    id: 1265799,
    name: 'Blight of Weakness',
    icon: 'warlock_curse_weakness_amplified',
    maxRanks: 1,
    entryIds: [136108],
    definitionIds: [{ id: 140863, specId: 267 }],
  },
  BURNING_RUSH_TALENT: {
    id: 111400,
    name: 'Burning Rush',
    icon: 'ability_deathwing_sealarmorbreachtga',
    maxRanks: 1,
    entryIds: [91460],
    definitionIds: [{ id: 96462, specId: 267 }],
  },
  CALL_DREADSTALKERS_TALENT: {
    id: 104316,
    name: 'Call Dreadstalkers',
    icon: 'spell_warlock_calldreadstalkers',
    maxRanks: 1,
    entryIds: [125837],
    definitionIds: [{ id: 130668, specId: 266 }],
    soulShardsCost: 2,
  },
  CARNIVOROUS_STALKERS_TALENT: {
    id: 386194,
    name: 'Carnivorous Stalkers',
    icon: 'warlock_pvp_callfelhunter',
    maxRanks: 2,
    entryIds: [125829],
    definitionIds: [{ id: 130660, specId: 266 }],
  },
  CASCADING_CALAMITY_TALENT: {
    id: 1261124,
    name: 'Cascading Calamity',
    icon: 'spell_shadow_unstableafllictions',
    maxRanks: 1,
    entryIds: [136115],
    definitionIds: [{ id: 140870, specId: 265 }],
  },
  CATACLYSM_TALENT: {
    id: 152108,
    name: 'Cataclysm',
    icon: 'achievement_zone_cataclysm',
    maxRanks: 1,
    entryIds: [91488],
    definitionIds: [{ id: 96490, specId: 267 }],
    manaCost: 2500,
  },
  CHANNEL_DEMONFIRE_TALENT: {
    id: 196447,
    name: 'Channel Demonfire',
    icon: 'spell_fire_ragnaros_lavaboltgreen',
    maxRanks: 1,
    entryIds: [128599],
    definitionIds: [{ id: 133402, specId: 267 }],
    manaCost: 3750,
  },
  CHAOS_BOLT_TALENT: {
    id: 116858,
    name: 'Chaos Bolt',
    icon: 'ability_warlock_chaosbolt',
    maxRanks: 1,
    entryIds: [136835],
    definitionIds: [{ id: 141598, specId: 267 }],
    soulShardsCost: 2,
  },
  CHAOS_INCARNATE_TALENT: {
    id: 387275,
    name: 'Chaos Incarnate',
    icon: 'spell_fire_felflamering',
    maxRanks: 1,
    entryIds: [91479],
    definitionIds: [{ id: 96481, specId: 267 }],
  },
  CHAOTIC_INFERNO_TALENT: {
    id: 1244788,
    name: 'Chaotic Inferno',
    icon: 'spell_fire_burnout',
    maxRanks: 1,
    entryIds: [91583],
    definitionIds: [{ id: 96585, specId: 267 }],
  },
  CLOVEN_SOULS_TALENT: {
    id: 428517,
    name: 'Cloven Souls',
    icon: 'ability_creature_felfrenzy',
    maxRanks: 1,
    entryIds: [117446],
    definitionIds: [{ id: 122458, specId: 267 }],
  },
  CONFLAGRATE_TALENT: {
    id: 17962,
    name: 'Conflagrate',
    icon: 'spell_fire_fireball',
    maxRanks: 1,
    entryIds: [91591],
    definitionIds: [{ id: 96593, specId: 267 }],
    manaCost: 2500,
  },
  CONFLAGRATION_OF_CHAOS_TALENT: {
    id: 387108,
    name: 'Conflagration of Chaos',
    icon: 'inv_shadowflame_buff',
    maxRanks: 1,
    entryIds: [91478],
    definitionIds: [{ id: 96480, specId: 267 }],
  },
  CONTAGION_TALENT: {
    id: 453096,
    name: 'Contagion',
    icon: 'spell_shadow_creepingplague',
    maxRanks: 1,
    entryIds: [91562],
    definitionIds: [{ id: 96564, specId: 265 }],
  },
  CRASHING_CHAOS_TALENT: {
    id: 417234,
    name: 'Crashing Chaos',
    icon: 'inv_infernalmount',
    maxRanks: 1,
    entryIds: [91473],
    definitionIds: [{ id: 96475, specId: 267 }],
  },
  CREEPING_DEATH_TALENT: {
    id: 264000,
    name: 'Creeping Death',
    icon: 'ability_creature_cursed_03',
    maxRanks: 2,
    entryIds: [91580],
    definitionIds: [{ id: 96582, specId: 265 }],
  },
  CRUELTY_OF_KERXAN_TALENT: {
    id: 429902,
    name: 'Cruelty of Kerxan',
    icon: 'creatureportrait_fomorhand',
    maxRanks: 1,
    entryIds: [117445],
    definitionIds: [{ id: 122457, specId: 267 }],
  },
  CULL_THE_WEAK_TALENT: {
    id: 1259886,
    name: 'Cull the Weak',
    icon: 'ability_warlock_soulsiphon',
    maxRanks: 1,
    entryIds: [136119],
    definitionIds: [{ id: 140874, specId: 265 }],
  },
  CUNNING_CRUELTY_TALENT: {
    id: 453172,
    name: 'Cunning Cruelty',
    icon: 'inv_misc_coin_09',
    maxRanks: 1,
    entryIds: [91576],
    definitionIds: [{ id: 96578, specId: 265 }],
  },
  CURSE_OF_EXHAUSTION_TALENT: {
    id: 334275,
    name: 'Curse of Exhaustion',
    icon: 'spell_shadow_grimward',
    maxRanks: 1,
    entryIds: [136107],
    definitionIds: [{ id: 140862, specId: 267 }],
    manaCost: 2500,
  },
  CURSE_OF_THE_SATYR_TALENT: {
    id: 440057,
    name: 'Curse of the Satyr',
    icon: 'inv_fabric_felrag',
    maxRanks: 1,
    entryIds: [117419],
    definitionIds: [{ id: 122431, specId: 267 }],
  },
  CURSE_OF_TONGUES_TALENT: {
    id: 1714,
    name: 'Curse of Tongues',
    icon: 'spell_shadow_curseoftounges',
    maxRanks: 1,
    entryIds: [136106],
    definitionIds: [{ id: 140861, specId: 267 }],
    manaCost: 2500,
  },
  DARK_ACCORD_TALENT: {
    id: 386659,
    name: 'Dark Accord',
    icon: 'ability_warlock_improveddemonictactics',
    maxRanks: 1,
    entryIds: [91467],
    definitionIds: [{ id: 96469, specId: 267 }],
  },
  DARK_HARVEST_TALENT: {
    id: 1257052,
    name: 'Dark Harvest',
    icon: 'inv_ability_warlock_soulrot',
    maxRanks: 1,
    entryIds: [136120],
    definitionIds: [{ id: 140875, specId: 265 }],
    manaCost: 2500,
  },
  DARK_PACT_TALENT: {
    id: 108416,
    name: 'Dark Pact',
    icon: 'spell_shadow_deathpact',
    maxRanks: 1,
    entryIds: [91444],
    definitionIds: [{ id: 96446, specId: 267 }],
  },
  DEATHS_EMBRACE_TALENT: {
    id: 234876,
    name: "Death's Embrace",
    icon: 'spell_shadow_deathsembrace',
    maxRanks: 1,
    entryIds: [91553],
    definitionIds: [{ id: 96555, specId: 265 }],
  },
  DEMONFIRE_INFUSION_TALENT: {
    id: 1214442,
    name: 'Demonfire Infusion',
    icon: 'spell_shadow_shadowandflame',
    maxRanks: 1,
    entryIds: [91586],
    definitionIds: [{ id: 96588, specId: 267 }],
  },
  DEMONIACS_FERVOR_TALENT: {
    id: 449629,
    name: "Demoniac's Fervor",
    icon: 'inv_helm_mask_zulgurub_d_01',
    maxRanks: 1,
    entryIds: [117429],
    definitionIds: [{ id: 122441, specId: 266 }],
  },
  DEMONIAC_TALENT: {
    id: 426115,
    name: 'Demoniac',
    icon: 'inv_demonbolt',
    maxRanks: 1,
    entryIds: [135306],
    definitionIds: [{ id: 140073, specId: 266 }],
  },
  DEMONIC_BRUTALITY_TALENT: {
    id: 453908,
    name: 'Demonic Brutality',
    icon: 'ability_demonhunter_bladedance',
    maxRanks: 1,
    entryIds: [125866],
    definitionIds: [{ id: 130697, specId: 266 }],
  },
  DEMONIC_CALLING_TALENT: {
    id: 1276947,
    name: 'Demonic Calling',
    icon: 'inv_felstalker_pet',
    maxRanks: 2,
    entryIds: [125848],
    definitionIds: [{ id: 130679, specId: 266 }],
  },
  DEMONIC_CIRCLE_TALENT: {
    id: 268358,
    name: 'Demonic Circle',
    icon: 'spell_shadow_demoniccirclesummon',
    maxRanks: 1,
    entryIds: [124694],
    definitionIds: [{ id: 129532, specId: 267 }],
    manaCost: 5000,
  },
  DEMONIC_EMBRACE_TALENT: {
    id: 288843,
    name: 'Demonic Embrace',
    icon: 'spell_shadow_metamorphosis',
    maxRanks: 1,
    entryIds: [91438],
    definitionIds: [{ id: 96440, specId: 267 }],
  },
  DEMONIC_FORTITUDE_TALENT: {
    id: 386617,
    name: 'Demonic Fortitude',
    icon: 'spell_warlock_summonimpoutland',
    maxRanks: 1,
    entryIds: [91430],
    definitionIds: [{ id: 96432, specId: 267 }],
  },
  DEMONIC_GATEWAY_TALENT: {
    id: 111771,
    name: 'Demonic Gateway',
    icon: 'spell_warlock_demonicportal_green',
    maxRanks: 1,
    entryIds: [91466],
    definitionIds: [{ id: 96468, specId: 267 }],
    manaCost: 25000,
  },
  DEMONIC_KNOWLEDGE_TALENT: {
    id: 386185,
    name: 'Demonic Knowledge',
    icon: 'ability_warlock_improveddemonictactics',
    maxRanks: 2,
    entryIds: [135311],
    definitionIds: [{ id: 140078, specId: 266 }],
  },
  DEMONIC_RESILIENCE_TALENT: {
    id: 389590,
    name: 'Demonic Resilience',
    icon: 'ability_warlock_avoidance',
    maxRanks: 1,
    entryIds: [91424],
    definitionIds: [{ id: 96426, specId: 267 }],
  },
  DEMONIC_SOUL_TALENT: {
    id: 449614,
    name: 'Demonic Soul',
    icon: 'inv_ability_soulharvesterwarlock_demonicsoul',
    maxRanks: 1,
    entryIds: [117448],
    definitionIds: [{ id: 122460, specId: 266 }],
  },
  DEMON_SKIN_TALENT: {
    id: 219272,
    name: 'Demon Skin',
    icon: 'spell_shadow_ragingscream',
    maxRanks: 2,
    entryIds: [91463],
    definitionIds: [{ id: 96465, specId: 267 }],
  },
  DESTRUCTIVE_RAPIDITY_TALENT: {
    id: 1244928,
    name: 'Destructive Rapidity',
    icon: 'spell_shadow_rainoffire',
    maxRanks: 1,
    entryIds: [91477],
    definitionIds: [{ id: 96479, specId: 267 }],
  },
  DEVASTATION_TALENT: {
    id: 454735,
    name: 'Devastation',
    icon: 'spell_fire_flameshock',
    maxRanks: 2,
    entryIds: [136834],
    definitionIds: [{ id: 141597, specId: 267 }],
  },
  DEVIL_FRUIT_TALENT: {
    id: 1266805,
    name: 'Devil Fruit',
    icon: 'inv_112_raidtrinkets_blobofswirlingvoid_terra',
    maxRanks: 1,
    entryIds: [136094],
    definitionIds: [{ id: 140849, specId: 267 }],
  },
  DIABOLIC_EMBERS_TALENT: {
    id: 387173,
    name: 'Diabolic Embers',
    icon: 'inv_shoulder_robe_raidmage_j_01',
    maxRanks: 1,
    entryIds: [91481],
    definitionIds: [{ id: 96483, specId: 267 }],
  },
  DIABOLIC_OCULI_TALENT: {
    id: 1268709,
    name: 'Diabolic Oculi',
    icon: 'inv_pet_inquisitoreye',
    maxRanks: 1,
    entryIds: [136092],
    definitionIds: [{ id: 140847, specId: 267 }],
  },
  DIABOLIC_RITUAL_TALENT: {
    id: 428514,
    name: 'Diabolic Ritual',
    icon: 'ability_bossfelorcs_necromancer_purple',
    maxRanks: 1,
    entryIds: [117452],
    definitionIds: [{ id: 122464, specId: 267 }],
  },
  DIMENSIONAL_RIFT_TALENT: {
    id: 1280868,
    name: 'Dimensional Rift',
    icon: 'inv_artifact_dimensionalrift',
    maxRanks: 1,
    entryIds: [128600],
    definitionIds: [{ id: 133403, specId: 267 }],
  },
  DOMINANT_HAND_TALENT: {
    id: 1276433,
    name: 'Dominant Hand',
    icon: 'warlock_curse_shadow',
    maxRanks: 1,
    entryIds: [136723],
    definitionIds: [{ id: 141495, specId: 266 }],
  },
  DOMINION_OF_ARGUS_1_DEMONOLOGY_TALENT: {
    id: 1276163,
    name: 'Dominion of Argus',
    icon: 'inv12_apextalent_warlock_dominionofargus',
    maxRanks: 1,
    entryIds: [136980],
    definitionIds: [{ id: 141743, specId: 266 }],
  },
  DOMINION_OF_ARGUS_2_DEMONOLOGY_TALENT: {
    id: 1276190,
    name: 'Dominion of Argus',
    icon: 'inv12_apextalent_warlock_dominionofargus',
    maxRanks: 2,
    entryIds: [136979],
    definitionIds: [{ id: 141742, specId: 266 }],
  },
  DOMINION_OF_ARGUS_3_DEMONOLOGY_TALENT: {
    id: 1276222,
    name: 'Dominion of Argus',
    icon: 'inv12_apextalent_warlock_dominionofargus',
    maxRanks: 1,
    entryIds: [136978],
    definitionIds: [{ id: 141741, specId: 266 }],
  },
  DOOM_TALENT: {
    id: 460551,
    name: 'Doom',
    icon: 'spell_shadow_auraofdarkness',
    maxRanks: 1,
    entryIds: [136729],
    definitionIds: [{ id: 141501, specId: 266 }],
  },
  DRAIN_SOUL_TALENT: {
    id: 388667,
    name: 'Drain Soul',
    icon: 'spell_shadow_haunting',
    maxRanks: 1,
    entryIds: [124692],
    definitionIds: [{ id: 129530, specId: 265 }],
  },
  DREADLASH_TALENT: {
    id: 264078,
    name: 'Dreadlash',
    icon: 'spell_shadow_summonvoidwalker',
    maxRanks: 1,
    entryIds: [125830],
    definitionIds: [{ id: 130661, specId: 266 }],
  },
  EMBERSTORM_TALENT: {
    id: 454744,
    name: 'Emberstorm',
    icon: 'spell_fire_selfdestruct',
    maxRanks: 1,
    entryIds: [91584],
    definitionIds: [{ id: 96586, specId: 267 }],
  },
  EMBERS_OF_NIHILAM_1_DESTRUCTION_TALENT: {
    id: 1265770,
    name: 'Embers of Nihilam',
    icon: 'inv12_apextalent_warlock_embersofnihilam',
    maxRanks: 1,
    entryIds: [136986],
    definitionIds: [{ id: 141749, specId: 267 }],
  },
  EMBERS_OF_NIHILAM_2_DESTRUCTION_TALENT: {
    id: 1265772,
    name: 'Embers of Nihilam',
    icon: 'inv12_apextalent_warlock_embersofnihilam',
    maxRanks: 2,
    entryIds: [136985],
    definitionIds: [{ id: 141748, specId: 267 }],
  },
  EMBERS_OF_NIHILAM_3_DESTRUCTION_TALENT: {
    id: 1265774,
    name: 'Embers of Nihilam',
    icon: 'inv12_apextalent_warlock_embersofnihilam',
    maxRanks: 1,
    entryIds: [136984],
    definitionIds: [{ id: 141747, specId: 267 }],
  },
  EMPOWERED_DRAIN_LIFE_TALENT: {
    id: 1271689,
    name: 'Empowered Drain Life',
    icon: 'spell_shadow_lifedrain02_purple',
    maxRanks: 1,
    entryIds: [136573],
    definitionIds: [{ id: 141346, specId: 267 }],
  },
  EMPOWERED_FELSTORM_TALENT: {
    id: 1279575,
    name: 'Empowered Felstorm',
    icon: 'inv_axe_2h_demonweapon_c_01',
    maxRanks: 1,
    entryIds: [136720],
    definitionIds: [{ id: 141492, specId: 266 }],
  },
  EMPOWERED_HEALTHSTONE_TALENT: {
    id: 1271699,
    name: 'Empowered Healthstone',
    icon: 'inv_raid_creepingcoagulum_blue',
    maxRanks: 1,
    entryIds: [136572],
    definitionIds: [{ id: 141345, specId: 267 }],
  },
  ETERNAL_HUNGER_TALENT: {
    id: 1268903,
    name: 'Eternal Hunger',
    icon: 'ability_creature_poison_01_purple',
    maxRanks: 1,
    entryIds: [136096],
    definitionIds: [{ id: 140851, specId: 266 }],
  },
  ETERNAL_SERVITUDE_TALENT: {
    id: 449707,
    name: 'Eternal Servitude',
    icon: 'ability_demonhunter_infernalchains',
    maxRanks: 1,
    entryIds: [117421],
    definitionIds: [{ id: 122433, specId: 266 }],
  },
  EXPLOSIVE_POTENTIAL_TALENT: {
    id: 388827,
    name: 'Explosive Potential',
    icon: 'spell_fire_felflamering_red',
    maxRanks: 1,
    entryIds: [91581],
    definitionIds: [{ id: 96583, specId: 267 }],
  },
  EYE_CONTRACT_TALENT: {
    id: 1279521,
    name: 'Eye Contract',
    icon: 'inv_misc_scrollunrolled01c',
    maxRanks: 1,
    entryIds: [136813],
    definitionIds: [{ id: 141576, specId: 265 }],
  },
  FATAL_ECHOES_TALENT: {
    id: 1260229,
    name: 'Fatal Echoes',
    icon: 'spell_shadow_unstableaffliction_3_purple',
    maxRanks: 1,
    entryIds: [136112],
    definitionIds: [{ id: 140867, specId: 265 }],
  },
  FEAST_OF_SOULS_TALENT: {
    id: 449706,
    name: 'Feast of Souls',
    icon: 'ability_warlock_improvedsoulleech',
    maxRanks: 1,
    entryIds: [123839],
    definitionIds: [{ id: 128677, specId: 266 }],
  },
  FEL_ARMAMENTS_TALENT: {
    id: 1263935,
    name: 'Fel Armaments',
    icon: 'inv_misc_desecrated_plategloves',
    maxRanks: 1,
    entryIds: [136229],
    definitionIds: [{ id: 141002, specId: 266 }],
  },
  FEL_ARMOR_TALENT: {
    id: 386124,
    name: 'Fel Armor',
    icon: 'spell_shadow_felarmour',
    maxRanks: 2,
    entryIds: [91461],
    definitionIds: [{ id: 96463, specId: 267 }],
  },
  FEL_DOMINATION_TALENT: {
    id: 333889,
    name: 'Fel Domination',
    icon: 'spell_shadow_felmending',
    maxRanks: 1,
    entryIds: [91439],
    definitionIds: [{ id: 96441, specId: 267 }],
  },
  FEL_INTELLECT_TALENT: {
    id: 1250372,
    name: 'Fel Intellect',
    icon: 'ability_kaztik_dominatemind',
    maxRanks: 1,
    entryIds: [135312],
    definitionIds: [{ id: 140079, specId: 266 }],
  },
  FEL_PACT_TALENT: {
    id: 386113,
    name: 'Fel Pact',
    icon: 'spell_shadow_impphaseshift',
    maxRanks: 1,
    entryIds: [91440],
    definitionIds: [{ id: 96442, specId: 267 }],
  },
  FEL_SYNERGY_TALENT: {
    id: 389367,
    name: 'Fel Synergy',
    icon: 'inv_sword_1h_felfireraid_d_01',
    maxRanks: 2,
    entryIds: [91432],
    definitionIds: [{ id: 96434, specId: 267 }],
  },
  FIENDISH_CRUELTY_TALENT: {
    id: 1245633,
    name: 'Fiendish Cruelty',
    icon: 'spell_fire_soulburn',
    maxRanks: 1,
    entryIds: [126004],
    definitionIds: [{ id: 130835, specId: 267 }],
  },
  FIENDISH_STRIDE_TALENT: {
    id: 386110,
    name: 'Fiendish Stride',
    icon: 'inv_misc_moosehoof_fel',
    maxRanks: 1,
    entryIds: [91459],
    definitionIds: [{ id: 96461, specId: 267 }],
  },
  FIRE_AND_BRIMSTONE_TALENT: {
    id: 196408,
    name: 'Fire and Brimstone',
    icon: 'ability_warlock_fireandbrimstone',
    maxRanks: 1,
    entryIds: [91499],
    definitionIds: [{ id: 96501, specId: 267 }],
  },
  FLAMES_OF_XOROTH_TALENT: {
    id: 429657,
    name: 'Flames of Xoroth',
    icon: 'ability_warlock_burningembers',
    maxRanks: 1,
    entryIds: [117430],
    definitionIds: [{ id: 122442, specId: 267 }],
  },
  FLAMETOUCHED_TALENT: {
    id: 453699,
    name: 'Flametouched',
    icon: 'spell_shaman_firenova',
    maxRanks: 1,
    entryIds: [125855],
    definitionIds: [{ id: 130686, specId: 266 }],
  },
  FLASHPOINT_TALENT: {
    id: 387259,
    name: 'Flashpoint',
    icon: 'spell_fire_moltenblood',
    maxRanks: 1,
    entryIds: [91485],
    definitionIds: [{ id: 96487, specId: 267 }],
  },
  FORTIFIED_SOUL_TALENT: {
    id: 1271694,
    name: 'Fortified Soul',
    icon: 'spell_warlock_demonsoul',
    maxRanks: 1,
    entryIds: [136571],
    definitionIds: [{ id: 141344, specId: 267 }],
  },
  FOUL_MOUTH_TALENT: {
    id: 1265813,
    name: 'Foul Mouth',
    icon: 'ability_creature_cursed_02',
    maxRanks: 1,
    entryIds: [136100],
    definitionIds: [{ id: 140855, specId: 267 }],
  },
  FREQUENT_DONOR_TALENT: {
    id: 386686,
    name: 'Frequent Donor',
    icon: 'ability_ironmaidens_bloodritual',
    maxRanks: 1,
    entryIds: [91445],
    definitionIds: [{ id: 96447, specId: 267 }],
  },
  FREQUENT_TRAVELER_TALENT: {
    id: 1265801,
    name: 'Frequent Traveler',
    icon: 'achievement_dungeon_outland_dungeonmaster',
    maxRanks: 1,
    entryIds: [136101],
    definitionIds: [{ id: 140856, specId: 267 }],
  },
  FRIENDS_IN_DARK_PLACES_TALENT: {
    id: 449703,
    name: 'Friends In Dark Places',
    icon: 'spell_shadow_deathpact',
    maxRanks: 1,
    entryIds: [123840],
    definitionIds: [{ id: 128678, specId: 266 }],
  },
  GLOOM_OF_NATHREZA_TALENT: {
    id: 429899,
    name: 'Gloom of Nathreza',
    icon: 'ability_rogue_envelopingshadows',
    maxRanks: 1,
    entryIds: [117440],
    definitionIds: [{ id: 122452, specId: 267 }],
  },
  GOREBOUND_FORTITUDE_TALENT: {
    id: 449701,
    name: 'Gorebound Fortitude',
    icon: 'spell_holy_consumemagic',
    maxRanks: 1,
    entryIds: [117447],
    definitionIds: [{ id: 122459, specId: 266 }],
  },
  GOREFIENDS_AVARICE_TALENT: {
    id: 1270701,
    name: "Gorefiend's Avarice",
    icon: 'inv_helmet_90',
    maxRanks: 1,
    entryIds: [91431],
    definitionIds: [{ id: 96433, specId: 267 }],
  },
  GOREFIENDS_RESOLVE_TALENT: {
    id: 389623,
    name: "Gorefiend's Resolve",
    icon: 'ability_rogue_masterofsubtlety',
    maxRanks: 1,
    entryIds: [123838],
    definitionIds: [{ id: 128676, specId: 266 }],
  },
  GRIMOIRE_FEL_RAVAGER_TALENT: {
    id: 1276467,
    name: 'Grimoire: Fel Ravager',
    icon: 'spell_shadow_summonfelhunter',
    maxRanks: 1,
    entryIds: [136725],
    definitionIds: [{ id: 141497, specId: 266 }],
    soulShardsCost: 1,
  },
  GRIMOIRE_IMP_LORD_TALENT: {
    id: 1276452,
    name: 'Grimoire: Imp Lord',
    icon: 'inv_imp3_purple',
    maxRanks: 1,
    entryIds: [136726],
    definitionIds: [{ id: 141498, specId: 266 }],
    soulShardsCost: 1,
  },
  GRIMOIRE_OF_SACRIFICE_TALENT: {
    id: 108503,
    name: 'Grimoire of Sacrifice',
    icon: 'warlock_grimoireofsacrifice',
    maxRanks: 1,
    entryIds: [124691, 125618],
    definitionIds: [
      { id: 129529, specId: 265 },
      { id: 130450, specId: 267 },
    ],
  },
  HAND_OF_GULDAN_TALENT: {
    id: 1250273,
    name: "Hand of Gul'dan",
    icon: 'ability_warlock_handofguldan',
    maxRanks: 1,
    entryIds: [125834],
    definitionIds: [{ id: 130665, specId: 266 }],
  },
  HATEFURY_RITUALS_TALENT: {
    id: 440048,
    name: 'Hatefury Rituals',
    icon: '70_inscription_glyph_demonhunter_minor',
    maxRanks: 1,
    entryIds: [117451],
    definitionIds: [{ id: 122463, specId: 267 }],
  },
  HAUNT_TALENT: {
    id: 48181,
    name: 'Haunt',
    icon: 'ability_warlock_haunt',
    maxRanks: 1,
    entryIds: [91552],
    definitionIds: [{ id: 96554, specId: 265 }],
    manaCost: 5000,
  },
  HAVOC_TALENT: {
    id: 80240,
    name: 'Havoc',
    icon: 'ability_warlock_baneofhavoc',
    maxRanks: 1,
    entryIds: [91493],
    definitionIds: [{ id: 96495, specId: 267 }],
    manaCost: 5000,
  },
  HELLBENT_COMMANDER_TALENT: {
    id: 1250897,
    name: 'Hellbent Commander',
    icon: 'inv_helm_cloth_pvpwarlock_o_01',
    maxRanks: 1,
    entryIds: [136727],
    definitionIds: [{ id: 141499, specId: 266 }],
  },
  HORRIFY_TALENT: {
    id: 56244,
    name: 'Horrify',
    icon: 'spell_nzinsanity_bloodthirst',
    maxRanks: 1,
    entryIds: [115459],
    definitionIds: [{ id: 120471, specId: 267 }],
  },
  HOWL_OF_TERROR_TALENT: {
    id: 5484,
    name: 'Howl of Terror',
    icon: 'ability_warlock_howlofterror',
    maxRanks: 1,
    entryIds: [91458],
    definitionIds: [{ id: 96460, specId: 267 }],
    manaCost: 4500,
  },
  ICHOR_OF_DEVILS_TALENT: {
    id: 386664,
    name: 'Ichor of Devils',
    icon: 'spell_yorsahj_bloodboil_greenoil',
    maxRanks: 1,
    entryIds: [91446],
    definitionIds: [{ id: 96448, specId: 267 }],
  },
  ILLHOOFS_DESIGN_TALENT: {
    id: 440070,
    name: "Illhoof's Design",
    icon: 'sha_spell_fire_felfireward_nightmare',
    maxRanks: 1,
    entryIds: [123308],
    definitionIds: [{ id: 128178, specId: 267 }],
  },
  IMPLOSION_TALENT: {
    id: 196277,
    name: 'Implosion',
    icon: 'inv_implosion',
    maxRanks: 1,
    entryIds: [125836],
    definitionIds: [{ id: 130667, specId: 266 }],
  },
  IMPROVED_CHAOS_BOLT_TALENT: {
    id: 456951,
    name: 'Improved Chaos Bolt',
    icon: 'ability_warlock_chaosbolt',
    maxRanks: 1,
    entryIds: [126002],
    definitionIds: [{ id: 130833, specId: 267 }],
  },
  IMPROVED_CONFLAGRATE_TALENT: {
    id: 231793,
    name: 'Improved Conflagrate',
    icon: 'spell_fire_fireball',
    maxRanks: 1,
    entryIds: [91587],
    definitionIds: [{ id: 96589, specId: 267 }],
  },
  IMPROVED_DEMONIC_TACTICS_TALENT: {
    id: 453800,
    name: 'Improved Demonic Tactics',
    icon: 'ability_warlock_ancientgrimoire',
    maxRanks: 1,
    entryIds: [125835],
    definitionIds: [{ id: 130666, specId: 266 }],
  },
  IMPROVED_HAUNT_TALENT: {
    id: 458034,
    name: 'Improved Haunt',
    icon: 'ability_warlock_haunt',
    maxRanks: 1,
    entryIds: [126064],
    definitionIds: [{ id: 130896, specId: 265 }],
  },
  IMPROVED_HAVOC_TALENT: {
    id: 1244460,
    name: 'Improved Havoc',
    icon: 'ability_warlock_baneofhavoc',
    maxRanks: 1,
    entryIds: [91474],
    definitionIds: [{ id: 96476, specId: 267 }],
  },
  IMPROVED_MORTAL_COIL_TALENT: {
    id: 1265816,
    name: 'Improved Mortal Coil',
    icon: 'spell_warlock_harvestoflife',
    maxRanks: 1,
    entryIds: [136105],
    definitionIds: [{ id: 140860, specId: 267 }],
  },
  IMPROVED_SHADOW_BOLT_TALENT: {
    id: 453080,
    name: 'Improved Shadow Bolt',
    icon: 'spell_shadow_shadowbolt',
    maxRanks: 1,
    entryIds: [91566],
    definitionIds: [{ id: 96568, specId: 265 }],
  },
  IMP_ERATOR_TALENT: {
    id: 416230,
    name: 'Imp-erator',
    icon: 'spell_warlock_summonimpoutland',
    maxRanks: 1,
    entryIds: [125869],
    definitionIds: [{ id: 130700, specId: 266 }],
  },
  IMP_GANG_BOSS_TALENT: {
    id: 1250768,
    name: 'Imp Gang Boss',
    icon: 'ability_warlock_empoweredimp',
    maxRanks: 1,
    entryIds: [135315],
    definitionIds: [{ id: 140082, specId: 266 }],
  },
  INFERNAL_BENEFICIARY_TALENT: {
    id: 1265810,
    name: 'Infernal Beneficiary',
    icon: 'achievement_general_raidrepresentation',
    maxRanks: 1,
    entryIds: [136104],
    definitionIds: [{ id: 140859, specId: 267 }],
  },
  INFERNAL_BULWARK_TALENT: {
    id: 429130,
    name: 'Infernal Bulwark',
    icon: 'spell_fire_felfireward',
    maxRanks: 1,
    entryIds: [118839],
    definitionIds: [{ id: 123739, specId: 267 }],
  },
  INFERNAL_MACHINE_TALENT: {
    id: 429917,
    name: 'Infernal Machine',
    icon: 'inv_misc_supersoulash',
    maxRanks: 1,
    entryIds: [118838],
    definitionIds: [{ id: 123738, specId: 267 }],
  },
  INFERNAL_RAPIDITY_TALENT: {
    id: 1263941,
    name: 'Infernal Rapidity',
    icon: 'spell_argus_withering_fire',
    maxRanks: 1,
    entryIds: [136227],
    definitionIds: [{ id: 141000, specId: 266 }],
  },
  INFERNAL_VITALITY_TALENT: {
    id: 429115,
    name: 'Infernal Vitality',
    icon: 'inv_fabric_felcloth_ebon',
    maxRanks: 1,
    entryIds: [117449],
    definitionIds: [{ id: 122461, specId: 267 }],
  },
  INFERNO_TALENT: {
    id: 1280483,
    name: 'Inferno',
    icon: 'warlock_pvp_burninglegion',
    maxRanks: 1,
    entryIds: [91489],
    definitionIds: [{ id: 96491, specId: 267 }],
  },
  INNER_DEMONS_TALENT: {
    id: 267216,
    name: 'Inner Demons',
    icon: 'ability_warlock_eradication',
    maxRanks: 1,
    entryIds: [136722],
    definitionIds: [{ id: 141494, specId: 266 }],
  },
  INTERNAL_COMBUSTION_TALENT: {
    id: 266134,
    name: 'Internal Combustion',
    icon: 'ability_mage_livingbomb',
    maxRanks: 1,
    entryIds: [91495],
    definitionIds: [{ id: 96497, specId: 267 }],
  },
  LAKE_OF_FIRE_TALENT: {
    id: 1244877,
    name: 'Lake of Fire',
    icon: 'spell_fire_ragnaros_molteninferno',
    maxRanks: 1,
    entryIds: [126493],
    definitionIds: [{ id: 131319, specId: 267 }],
  },
  LOOKS_THAT_KILL_TALENT: {
    id: 1268713,
    name: 'Looks That Kill',
    icon: 'ability_bosskilrogg_deadeye',
    maxRanks: 1,
    entryIds: [136091],
    definitionIds: [{ id: 140846, specId: 267 }],
  },
  MALEDICTION_TALENT: {
    id: 453087,
    name: 'Malediction',
    icon: 'spell_shadow_curseofachimonde',
    maxRanks: 1,
    entryIds: [91567],
    definitionIds: [{ id: 96569, specId: 265 }],
  },
  MALEFIC_GRASP_TALENT: {
    id: 1261149,
    name: 'Malefic Grasp',
    icon: 'ability_warlock_everlastingaffliction',
    maxRanks: 1,
    entryIds: [136118],
    definitionIds: [{ id: 140873, specId: 265 }],
  },
  MALEVOLENCE_TALENT: {
    id: 430014,
    name: 'Malevolence',
    icon: 'inv_ability_hellcallerwarlock_malevolence',
    maxRanks: 1,
    entryIds: [117439],
    definitionIds: [{ id: 122451, specId: 267 }],
  },
  MANIFESTED_AVARICE_TALENT: {
    id: 1268884,
    name: 'Manifested Avarice',
    icon: 'ability_priest_shadowyapparition',
    maxRanks: 1,
    entryIds: [136098],
    definitionIds: [{ id: 140853, specId: 266 }],
  },
  MARK_OF_FHARG_TALENT: {
    id: 455450,
    name: "Mark of F'harg",
    icon: 'inv_felhound3_shadow_fire',
    maxRanks: 1,
    entryIds: [125838],
    definitionIds: [{ id: 130669, specId: 266 }],
  },
  MARK_OF_PEROTHARN_TALENT: {
    id: 440045,
    name: "Mark of Peroth'arn",
    icon: '70_inscription_vantus_rune_tomb',
    maxRanks: 1,
    entryIds: [117441],
    definitionIds: [{ id: 122453, specId: 267 }],
  },
  MARK_OF_SHATUG_TALENT: {
    id: 455449,
    name: 'Mark of Shatug',
    icon: 'inv_felhound3_shadow_mount',
    maxRanks: 1,
    entryIds: [125839],
    definitionIds: [{ id: 130670, specId: 266 }],
  },
  MARK_OF_XAVIUS_TALENT: {
    id: 440046,
    name: 'Mark of Xavius',
    icon: 'warlock_curse_shadow_aura',
    maxRanks: 1,
    entryIds: [117431],
    definitionIds: [{ id: 122443, specId: 267 }],
  },
  MASTER_SUMMONER_TALENT: {
    id: 1240189,
    name: 'Master Summoner',
    icon: 'spell_nature_removecurse',
    maxRanks: 1,
    entryIds: [125854],
    definitionIds: [{ id: 130685, specId: 266 }],
  },
  MAYHEM_TALENT: {
    id: 387506,
    name: 'Mayhem',
    icon: 'spell_warlock_demonbolt',
    maxRanks: 1,
    entryIds: [91494],
    definitionIds: [{ id: 96496, specId: 267 }],
  },
  MINDS_EYES_TALENT: {
    id: 1268716,
    name: "Mind's Eyes",
    icon: 'spell_holy_healingfocus',
    maxRanks: 1,
    entryIds: [136090],
    definitionIds: [{ id: 140845, specId: 267 }],
  },
  MORTAL_COIL_TALENT: {
    id: 6789,
    name: 'Mortal Coil',
    icon: 'ability_warlock_mortalcoil',
    maxRanks: 1,
    entryIds: [91452],
    definitionIds: [{ id: 96454, specId: 267 }],
    manaCost: 5000,
  },
  NECROLYTE_TEACHINGS_TALENT: {
    id: 449620,
    name: 'Necrolyte Teachings',
    icon: 'spell_necro_deathall',
    maxRanks: 1,
    entryIds: [117422],
    definitionIds: [{ id: 122434, specId: 266 }],
  },
  NETHER_PLATING_TALENT: {
    id: 1280733,
    name: 'Nether Plating',
    icon: 'inv_antorus_orange',
    maxRanks: 1,
    entryIds: [91504],
    definitionIds: [{ id: 96506, specId: 265 }],
  },
  NIGHTFALL_TALENT: {
    id: 108558,
    name: 'Nightfall',
    icon: 'spell_shadow_twilight',
    maxRanks: 1,
    entryIds: [91568],
    definitionIds: [{ id: 96570, specId: 265 }],
  },
  NIGHTMARE_TALENT: {
    id: 386648,
    name: 'Nightmare',
    icon: 'spell_shadow_possession',
    maxRanks: 1,
    entryIds: [91422],
    definitionIds: [{ id: 96424, specId: 267 }],
  },
  NISKARAN_METHODS_TALENT: {
    id: 1279510,
    name: 'Niskaran Methods',
    icon: 'inv_lightforgedmatrixability_felheartofargus',
    maxRanks: 1,
    entryIds: [136123],
    definitionIds: [{ id: 140878, specId: 265 }],
  },
  NOCTURNAL_YIELD_TALENT: {
    id: 1260271,
    name: 'Nocturnal Yield',
    icon: 'inv_nulllotus_shadow',
    maxRanks: 1,
    entryIds: [136111],
    definitionIds: [{ id: 140866, specId: 265 }],
  },
  OPPRESSIVE_DARKNESS_TALENT: {
    id: 1270255,
    name: 'Oppressive Darkness',
    icon: 'spell_shadow_shadowfury',
    maxRanks: 1,
    entryIds: [91451],
    definitionIds: [{ id: 96453, specId: 267 }],
  },
  PACT_OF_GLUTTONY_TALENT: {
    id: 386689,
    name: 'Pact of Gluttony',
    icon: 'warlock__bloodstone',
    maxRanks: 1,
    entryIds: [91434],
    definitionIds: [{ id: 96436, specId: 267 }],
  },
  PACT_OF_THE_ANNIHILAN_TALENT: {
    id: 1270693,
    name: 'Pact of the Annihilan',
    icon: 'inv_misc_magtheridonshead',
    maxRanks: 1,
    entryIds: [136568],
    definitionIds: [{ id: 141341, specId: 267 }],
  },
  PACT_OF_THE_EREDAR_TALENT: {
    id: 1270695,
    name: 'Pact of the Eredar',
    icon: 'achievement_boss_argus_femaleeredar',
    maxRanks: 1,
    entryIds: [136103],
    definitionIds: [{ id: 140858, specId: 267 }],
  },
  PACT_OF_THE_NATHREZIM_TALENT: {
    id: 1270690,
    name: 'Pact of the Nathrezim',
    icon: 'ability_physical_taunt_purple',
    maxRanks: 1,
    entryIds: [136570],
    definitionIds: [{ id: 141343, specId: 267 }],
  },
  PACT_OF_THE_SATYR_TALENT: {
    id: 1270691,
    name: 'Pact of the Satyr',
    icon: 'spell_shadow_mindshear',
    maxRanks: 1,
    entryIds: [136569],
    definitionIds: [{ id: 141342, specId: 267 }],
  },
  PATIENT_ZERO_TALENT: {
    id: 1260285,
    name: 'Patient Zero',
    icon: 'ability_warlock_soulswap',
    maxRanks: 1,
    entryIds: [136113],
    definitionIds: [{ id: 140868, specId: 265 }],
  },
  POTENT_SOUL_SHARDS_TALENT: {
    id: 1259815,
    name: 'Potent Soul Shards',
    icon: 'inv_misc_gem_amethyst_02',
    maxRanks: 1,
    entryIds: [136124],
    definitionIds: [{ id: 140879, specId: 265 }],
  },
  POWER_SIPHON_TALENT: {
    id: 264130,
    name: 'Power Siphon',
    icon: 'ability_warlock_backdraft',
    maxRanks: 1,
    entryIds: [136731],
    definitionIds: [{ id: 141503, specId: 266 }],
  },
  PRACTICED_CHAOS_TALENT: {
    id: 1244284,
    name: 'Practiced Chaos',
    icon: 'ability_demonhunter_chaoticimprint_fire',
    maxRanks: 1,
    entryIds: [134219],
    definitionIds: [{ id: 138997, specId: 267 }],
  },
  PRACTICED_PESTILENCE_TALENT: {
    id: 1259811,
    name: 'Practiced Pestilence',
    icon: 'spell_nature_agitatingtotem',
    maxRanks: 1,
    entryIds: [136812],
    definitionIds: [{ id: 141575, specId: 265 }],
  },
  PRACTICED_RITUALS_TALENT: {
    id: 1250375,
    name: 'Practiced Rituals',
    icon: 'inv_10_inscription_illusoryspellscrolls_color4',
    maxRanks: 1,
    entryIds: [135313],
    definitionIds: [{ id: 140080, specId: 266 }],
  },
  QUIETUS_TALENT: {
    id: 449634,
    name: 'Quietus',
    icon: 'spell_necro_conclave',
    maxRanks: 1,
    entryIds: [117443],
    definitionIds: [{ id: 122455, specId: 266 }],
  },
  RAGING_DEMONFIRE_TALENT: {
    id: 387166,
    name: 'Raging Demonfire',
    icon: 'spell_fire_ragnaros_lavaboltgreen',
    maxRanks: 1,
    entryIds: [126003],
    definitionIds: [{ id: 130834, specId: 267 }],
  },
  RAIN_OF_CHAOS_TALENT: {
    id: 266086,
    name: 'Rain of Chaos',
    icon: 'spell_fire_felrainoffire',
    maxRanks: 1,
    entryIds: [126494],
    definitionIds: [{ id: 131320, specId: 267 }],
  },
  RAIN_OF_FIRE_1_DESTRUCTION_TALENT: {
    id: 5740,
    name: 'Rain of Fire',
    icon: 'spell_shadow_rainoffire',
    maxRanks: 1,
    entryIds: [91592],
    definitionIds: [{ id: 96594, specId: 267 }],
    soulShardsCost: 3,
  },
  RAIN_OF_FIRE_2_DESTRUCTION_TALENT: {
    id: 1214467,
    name: 'Rain of Fire',
    icon: 'spell_shadow_rainoffire',
    maxRanks: 1,
    entryIds: [128601],
    definitionIds: [{ id: 133404, specId: 267 }],
    soulShardsCost: 3,
  },
  RAVENOUS_AFFLICTIONS_TALENT: {
    id: 459440,
    name: 'Ravenous Afflictions',
    icon: 'ability_warlock_improvedsoulleech',
    maxRanks: 1,
    entryIds: [126303],
    definitionIds: [{ id: 131129, specId: 265 }],
  },
  REIGN_OF_TYRANNY_TALENT: {
    id: 1276748,
    name: 'Reign of Tyranny',
    icon: 'ability_warlock_demonicpower',
    maxRanks: 1,
    entryIds: [136730],
    definitionIds: [{ id: 141502, specId: 266 }],
  },
  REVERSE_ENTROPY_TALENT: {
    id: 205148,
    name: 'Reverse Entropy',
    icon: 'spell_fire_playingwithfiregreen',
    maxRanks: 1,
    entryIds: [91496],
    definitionIds: [{ id: 96498, specId: 267 }],
  },
  ROARING_BLAZE_TALENT: {
    id: 1244310,
    name: 'Roaring Blaze',
    icon: 'ability_warlock_inferno',
    maxRanks: 1,
    entryIds: [91588],
    definitionIds: [{ id: 96590, specId: 267 }],
  },
  RUINATION_TALENT: {
    id: 428522,
    name: 'Ruination',
    icon: 'ability_bossmannoroth_empoweredmannorothsgaze',
    maxRanks: 1,
    entryIds: [117427],
    definitionIds: [{ id: 122439, specId: 267 }],
  },
  RUIN_TALENT: {
    id: 387103,
    name: 'Ruin',
    icon: 'spell_shadow_shadowwordpain',
    maxRanks: 2,
    entryIds: [91589],
    definitionIds: [{ id: 96591, specId: 267 }],
  },
  RUNE_OF_SHADOWS_TALENT: {
    id: 453744,
    name: 'Rune of Shadows',
    icon: 'spell_shadow_rune',
    maxRanks: 2,
    entryIds: [125860],
    definitionIds: [{ id: 130691, specId: 266 }],
  },
  SACRIFICED_SOULS_TALENT: {
    id: 267214,
    name: 'Sacrificed Souls',
    icon: 'ability_creature_disease_05',
    maxRanks: 1,
    entryIds: [125828],
    definitionIds: [{ id: 130659, specId: 266 }],
  },
  SACROLASHS_DARK_STRIKE_TALENT: {
    id: 386986,
    name: "Sacrolash's Dark Strike",
    icon: 'spell_nzinsanity_fearofdeath',
    maxRanks: 1,
    entryIds: [136110],
    definitionIds: [{ id: 140865, specId: 265 }],
  },
  SATAIELS_VOLITION_TALENT: {
    id: 449637,
    name: "Sataiel's Volition",
    icon: 'spell_necro_deathlyecho',
    maxRanks: 1,
    entryIds: [117435],
    definitionIds: [{ id: 122447, specId: 266 }],
  },
  SCALDING_FLAMES_TALENT: {
    id: 388832,
    name: 'Scalding Flames',
    icon: 'spell_burningsoul',
    maxRanks: 1,
    entryIds: [91486],
    definitionIds: [{ id: 96488, specId: 267 }],
  },
  SECRETS_OF_THE_COVEN_TALENT: {
    id: 428518,
    name: 'Secrets of the Coven',
    icon: 'achievement_boss_argus_shivan',
    maxRanks: 1,
    entryIds: [117423],
    definitionIds: [{ id: 122435, specId: 267 }],
  },
  SEEDS_OF_DESTRUCTION_TALENT: {
    id: 1259838,
    name: 'Seeds of Destruction',
    icon: 'sha_inv_elemental_primal_shadow_nightmare',
    maxRanks: 2,
    entryIds: [136126],
    definitionIds: [{ id: 140881, specId: 265 }],
  },
  SEEDS_OF_THEIR_DEMISE_TALENT: {
    id: 440055,
    name: 'Seeds of Their Demise',
    icon: 'ability_warlock_moltencoregreen',
    maxRanks: 1,
    entryIds: [117426],
    definitionIds: [{ id: 122438, specId: 267 }],
  },
  SEED_OF_CORRUPTION_TALENT: {
    id: 27243,
    name: 'Seed of Corruption',
    icon: 'spell_shadow_seedofdestruction',
    maxRanks: 1,
    entryIds: [91571],
    definitionIds: [{ id: 96573, specId: 265 }],
    soulShardsCost: 1,
  },
  SHADOWBURN_TALENT: {
    id: 17877,
    name: 'Shadowburn',
    icon: 'spell_shadow_scourgebuild',
    maxRanks: 1,
    entryIds: [91582],
    definitionIds: [{ id: 96584, specId: 267 }],
    soulShardsCost: 1,
  },
  SHADOWFURY_TALENT: {
    id: 30283,
    name: 'Shadowfury',
    icon: 'ability_warlock_shadowfurytga',
    maxRanks: 1,
    entryIds: [91457],
    definitionIds: [{ id: 96459, specId: 267 }],
    manaCost: 2500,
  },
  SHADOW_OF_DEATH_TALENT: {
    id: 449638,
    name: 'Shadow of Death',
    icon: 'spell_arcane_prismaticcloak',
    maxRanks: 1,
    entryIds: [117454],
    definitionIds: [{ id: 122466, specId: 266 }],
  },
  SHADOW_OF_NATHREZA_1_AFFLICTION_TALENT: {
    id: 1261984,
    name: 'Shadow of Nathreza',
    icon: 'inv12_apextalent_warlock_shadowsofnathreza',
    maxRanks: 1,
    entryIds: [136983],
    definitionIds: [{ id: 141746, specId: 265 }],
  },
  SHADOW_OF_NATHREZA_2_AFFLICTION_TALENT: {
    id: 1261990,
    name: 'Shadow of Nathreza',
    icon: 'inv12_apextalent_warlock_shadowsofnathreza',
    maxRanks: 2,
    entryIds: [136982],
    definitionIds: [{ id: 141745, specId: 265 }],
  },
  SHADOW_OF_NATHREZA_3_AFFLICTION_TALENT: {
    id: 1261992,
    name: 'Shadow of Nathreza',
    icon: 'inv12_apextalent_warlock_shadowsofnathreza',
    maxRanks: 1,
    entryIds: [136981],
    definitionIds: [{ id: 141744, specId: 265 }],
  },
  SHARD_INSTABILITY_TALENT: {
    id: 1260264,
    name: 'Shard Instability',
    icon: 'spell_warlock_focusshadow',
    maxRanks: 1,
    entryIds: [136117],
    definitionIds: [{ id: 140872, specId: 265 }],
  },
  SHARED_AGONY_TALENT: {
    id: 1259825,
    name: 'Shared Agony',
    icon: 'spell_shadow_curseofsargeras',
    maxRanks: 1,
    entryIds: [136121],
    definitionIds: [{ id: 140876, specId: 265 }],
  },
  SHARED_FATE_TALENT: {
    id: 449704,
    name: 'Shared Fate',
    icon: 'ability_warlock_soullink',
    maxRanks: 1,
    entryIds: [117420],
    definitionIds: [{ id: 122432, specId: 266 }],
  },
  SHARED_VESSEL_TALENT: {
    id: 1268889,
    name: 'Shared Vessel',
    icon: 'inv_ability_priest_mindgames',
    maxRanks: 1,
    entryIds: [136097],
    definitionIds: [{ id: 140852, specId: 266 }],
  },
  SIPHON_LIFE_TALENT: {
    id: 452999,
    name: 'Siphon Life',
    icon: 'spell_shadow_requiem',
    maxRanks: 1,
    entryIds: [124693],
    definitionIds: [{ id: 129531, specId: 265 }],
  },
  SOULBURN_TALENT: {
    id: 385899,
    name: 'Soulburn',
    icon: 'spell_warlock_soulburn',
    maxRanks: 1,
    entryIds: [91469],
    definitionIds: [{ id: 96471, specId: 267 }],
    soulShardsCost: 1,
  },
  SOUL_ANATHEMA_TALENT: {
    id: 449624,
    name: 'Soul Anathema',
    icon: 'spell_necro_inevitableend',
    maxRanks: 1,
    entryIds: [117444],
    definitionIds: [{ id: 122456, specId: 266 }],
  },
  SOUL_ETCHED_CIRCLES_TALENT: {
    id: 428911,
    name: 'Soul-Etched Circles',
    icon: 'spell_shadow_demoniccircleteleport',
    maxRanks: 1,
    entryIds: [117433],
    definitionIds: [{ id: 122445, specId: 267 }],
  },
  SOUL_FIRE_TALENT: {
    id: 6353,
    name: 'Soul Fire',
    icon: 'spell_fire_firebolt',
    maxRanks: 1,
    entryIds: [134221],
    definitionIds: [{ id: 138999, specId: 267 }],
    manaCost: 5000,
  },
  SOUL_LEECH_TALENT: {
    id: 108370,
    name: 'Soul Leech',
    icon: 'warlock_siphonlife',
    maxRanks: 1,
    entryIds: [91441],
    definitionIds: [{ id: 96443, specId: 267 }],
  },
  SOUL_LINK_TALENT: {
    id: 108415,
    name: 'Soul Link',
    icon: 'ability_warlock_soullink',
    maxRanks: 2,
    entryIds: [136102],
    definitionIds: [{ id: 140857, specId: 267 }],
  },
  SOW_THE_SEEDS_TALENT: {
    id: 196226,
    name: 'Sow the Seeds',
    icon: 'spell_shadow_seedofdestruction',
    maxRanks: 1,
    entryIds: [136114],
    definitionIds: [{ id: 140869, specId: 265 }],
  },
  SPITEFUL_RECONSTITUTION_TALENT: {
    id: 428394,
    name: 'Spiteful Reconstitution',
    icon: 'spell_shadow_impphaseshift',
    maxRanks: 1,
    entryIds: [136721],
    definitionIds: [{ id: 141493, specId: 266 }],
  },
  STABILIZED_PORTALS_TALENT: {
    id: 1276661,
    name: 'Stabilized Portals',
    icon: 'ability_demonhunter_netherbond',
    maxRanks: 1,
    entryIds: [136724],
    definitionIds: [{ id: 141496, specId: 266 }],
  },
  STRENGTH_OF_WILL_TALENT: {
    id: 317138,
    name: 'Strength of Will',
    icon: 'spell_shadow_demonictactics',
    maxRanks: 1,
    entryIds: [91468],
    definitionIds: [{ id: 96470, specId: 267 }],
  },
  SUDDEN_ONSET_TALENT: {
    id: 1260209,
    name: 'Sudden Onset',
    icon: 'spell_shadow_curseofsargeras',
    maxRanks: 1,
    entryIds: [136109],
    definitionIds: [{ id: 140864, specId: 265 }],
  },
  SUMMONERS_EMBRACE_TALENT: {
    id: 453105,
    name: "Summoner's Embrace",
    icon: 'spell_shadow_unsummonbuilding',
    maxRanks: 1,
    entryIds: [91558, 91484],
    definitionIds: [
      { id: 96560, specId: 265 },
      { id: 96486, specId: 267 },
    ],
  },
  SUMMON_DARKGLARE_TALENT: {
    id: 205180,
    name: 'Summon Darkglare',
    icon: 'inv_beholderwarlock',
    maxRanks: 1,
    entryIds: [91554],
    definitionIds: [{ id: 96556, specId: 265 }],
    manaCost: 5000,
  },
  SUMMON_DEMONIC_TYRANT_TALENT: {
    id: 265187,
    name: 'Summon Demonic Tyrant',
    icon: 'inv_summondemonictyrant',
    maxRanks: 1,
    entryIds: [125850],
    definitionIds: [{ id: 130681, specId: 266 }],
    manaCost: 5000,
  },
  SUMMON_DOOMGUARD_TALENT: {
    id: 1276672,
    name: 'Summon Doomguard',
    icon: 'warlock_summon_doomguard',
    maxRanks: 1,
    entryIds: [125863],
    definitionIds: [{ id: 130694, specId: 266 }],
    soulShardsCost: 1,
  },
  SUMMON_FELGUARD_TALENT: {
    id: 30146,
    name: 'Summon Felguard',
    icon: 'spell_shadow_summonfelguard',
    maxRanks: 1,
    entryIds: [135319],
    definitionIds: [{ id: 140086, specId: 266 }],
    soulShardsCost: 1,
  },
  SUMMON_INFERNAL_TALENT: {
    id: 1122,
    name: 'Summon Infernal',
    icon: 'spell_shadow_summoninfernal',
    maxRanks: 1,
    entryIds: [91502],
    definitionIds: [{ id: 96504, specId: 267 }],
    manaCost: 5000,
  },
  SUMMON_VILEFIEND_TALENT: {
    id: 1251778,
    name: 'Summon Vilefiend',
    icon: 'inv_argusfelstalkermount',
    maxRanks: 1,
    entryIds: [135314],
    definitionIds: [{ id: 140081, specId: 266 }],
  },
  SWIFT_ARTIFICE_TALENT: {
    id: 452902,
    name: 'Swift Artifice',
    icon: 'spell_shadow_destructivesoul',
    maxRanks: 1,
    entryIds: [91425],
    definitionIds: [{ id: 96427, specId: 267 }],
  },
  TEACHINGS_OF_THE_BLACK_HARVEST_TALENT: {
    id: 385881,
    name: 'Teachings of the Black Harvest',
    icon: 'inv_misc_codexofxerrath_nochains',
    maxRanks: 1,
    entryIds: [91447],
    definitionIds: [{ id: 96449, specId: 267 }],
  },
  THROUGH_THE_FELVINE_TALENT: {
    id: 1266799,
    name: 'Through the Felvine',
    icon: 'spell_nature_thorns_nightmare',
    maxRanks: 1,
    entryIds: [136095],
    definitionIds: [{ id: 140850, specId: 267 }],
  },
  TOUCH_OF_RANCORA_TALENT: {
    id: 429893,
    name: 'Touch of Rancora',
    icon: 'ability_bossfellord_felspike',
    maxRanks: 1,
    entryIds: [117453],
    definitionIds: [{ id: 122465, specId: 267 }],
  },
  TO_HELL_AND_BACK_TALENT: {
    id: 1281511,
    name: 'To Hell and Back',
    icon: 'ability_warlock_impoweredimp',
    maxRanks: 1,
    entryIds: [136728],
    definitionIds: [{ id: 141500, specId: 266 }],
  },
  TYRANTS_OBLATION_TALENT: {
    id: 1276746,
    name: "Tyrant's Oblation",
    icon: 'spell_warlock_demonwrath',
    maxRanks: 1,
    entryIds: [136719],
    definitionIds: [{ id: 141491, specId: 266 }],
  },
  UNSTABLE_AFFLICTION_TALENT: {
    id: 1259790,
    name: 'Unstable Affliction',
    icon: 'spell_shadow_unstableaffliction_3',
    maxRanks: 1,
    entryIds: [136122],
    definitionIds: [{ id: 140877, specId: 265 }],
    soulShardsCost: 1,
  },
  WICKED_REAPING_TALENT: {
    id: 449631,
    name: 'Wicked Reaping',
    icon: 'inv_staff_2h_artifactdeadwind_d_05',
    maxRanks: 1,
    entryIds: [117418],
    definitionIds: [{ id: 122430, specId: 266 }],
  },
  WITHERING_BOLT_TALENT: {
    id: 386976,
    name: 'Withering Bolt',
    icon: 'spell_shadow_shadowbolt',
    maxRanks: 2,
    entryIds: [91577],
    definitionIds: [{ id: 96579, specId: 265 }],
  },
  WITHER_TALENT: {
    id: 445465,
    name: 'Wither',
    icon: 'inv_ability_hellcallerwarlock_wither',
    maxRanks: 1,
    entryIds: [117437],
    definitionIds: [{ id: 122449, specId: 267 }],
  },
  XALANS_CRUELTY_TALENT: {
    id: 440040,
    name: "Xalan's Cruelty",
    icon: 'spell_shadow_demonicempathy',
    maxRanks: 1,
    entryIds: [117442],
    definitionIds: [{ id: 122454, specId: 267 }],
  },
  XALANS_FEROCITY_TALENT: {
    id: 440044,
    name: "Xalan's Ferocity",
    icon: 'spell_fire_felfire',
    maxRanks: 1,
    entryIds: [117450],
    definitionIds: [{ id: 122462, specId: 267 }],
  },
  XAVIUS_GAMBIT_TALENT: {
    id: 416615,
    name: "Xavius' Gambit",
    icon: 'spell_shadow_mindshear',
    maxRanks: 2,
    entryIds: [136125],
    definitionIds: [{ id: 140880, specId: 265 }],
  },
  ZEVRIMS_RESILIENCE_TALENT: {
    id: 440065,
    name: "Zevrim's Resilience",
    icon: 'ability_warrior_intensifyrage',
    maxRanks: 1,
    entryIds: [117432],
    definitionIds: [{ id: 122444, specId: 267 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_WARLOCK };
